export const ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA = 'ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/bikeModel.constants.js